import _ from '../../core/utils'

const MAP_CASES_CONFIG = {
    el: _.select( '.map__cases' ),
    endpoint: 'cases/get/'
}

export default MAP_CASES_CONFIG